import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"

import "./Huds.less"

window.tutorial = window.tutorial || {}

const tutorials = [
    {
        "anchor": {"x": 0.5, "y": 0.5},
        "position": {"x": 8, "y": 1.33},
        "condition": (stage) => {
            return window.tutorial.hasSelected != true
                && stage.currentEncounterKey == 1
                && stage.turn.number == 0
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">Click on an adventurer to select them.</div>
                </div>
            )
        }
    },
    {
        "anchor": {"x": 0.5, "y": 0.5},
        "position": {"x": 8, "y": 9-1.33},
        "condition": (stage) => {
            return stage.flags["tutorial:hasAttacked"] != true
                && stage.currentEncounterKey == 1
                && stage.turn.number == 0
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">Now click on a monster to attack!!</div>
                </div>
            )
        }
    },
    {
        "anchor": {"x": 0.5, "y": 0.5},
        "position": {"x": 16*0.8, "y": 9/2},
        "condition": (stage) => {
            return stage.flags["tutorial:hasAttackedSuperEffectively"] == true
                // && stage.flags["tutorial:latestAttackEffectivity"] == "isSuperEffective"
                && window.tutorial.hasDismissedSuperEffectives != true
                && stage.currentEncounterKey == 1
                && stage.turn.number == 0
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">
                        😃 Super-effective!! You attacked twice<br/>
                        because <Element>{stage.flags["tutorial:SuperEffectiveAttackerElement"]}</Element> is
                        strong against <Element>{stage.flags["tutorial:SuperEffectiveAttackedElement"]}</Element>!!
                    </div>
                    <div class="Link" onClick={() => window.tutorial.hasDismissedSuperEffectives = true}>
                        ✖ Dismiss
                    </div>
                </div>
            )
        }
    },
    {
        "anchor": {"x": 0, "y": 0},
        "position": {"x": 0.5, "y": 2.5},
        "condition": (stage) => {
            return Object.values(stage.units).filter((unit) => {
                return unit.affiliation == stage.player.affiliation
                    && unit.isDead != true
                    && Zone.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
            }).every((unit) =>  unit.energy["move"] == false && unit.energy["invoke skill"] == false)
                && stage.currentEncounterKey == 1
                && stage.turn.phase == "start"
                && stage.turn.number == 0
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">
                        ☝️ Excellent! Now end your turn.
                    </div>
                </div>
            )
        }
    },
    {
        "anchor": {"x": 0, "y": 0},
        "position": {"x": 0.5, "y": 0.5},
        "condition": (stage) => {
            return stage.player.phase == "rolling"
                && window.tutorial.hasDismissedRightClicks  != true
                && stage.currentEncounterKey == 1
                && stage.turn.phase == "start"
                && stage.turn.number == 2
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">
                        See something you like?<br/>
                        Click on the dice to lock it in!!<br/>
                        (Or right-click to read more)
                    </div>
                    <div class="Link" onClick={() => window.tutorial.hasDismissedRightClicks = true}>
                        ✖ Dismiss
                    </div>
                </div>
            )
        }
    },
    // {
    //     "anchor": {"x": 0.5, "y": 0.5},
    //     "position": {"x": 16*0.2, "y": 9/2},
    //     "condition": (stage) => {
    //         return stage.flags["tutorial:hasAttackedIneffectively"] == true
    //             // && stage.flags["tutorial:latestAttackEffectivity"] == "isIneffective"
    //             && window.tutorial.hasDismissedInEffectives != true
    //             && stage.currentEncounterKey == 1
    //             && stage.turn.number == 2
    //     },
    //     "content": (stage) => {
    //         return (
    //             <div class="TutorialBox">
    //                 <div class="Text">
    //                     ☹️ Not very effective... Your damage was<br/>
    //                     halved because <Element>{stage.flags["tutorial:IneffectiveAttackerElement"]}</Element> is
    //                     weak against <Element>{stage.flags["tutorial:IneffectiveAttackedElement"]}</Element>.<br/>
    //                 </div>
    //                 <div class="Link" onClick={() => window.tutorial.hasDismissedIneffectives = true}>
    //                     ✖ Dismiss
    //                 </div>
    //             </div>
    //         )
    //     }
    // },
    {
        "anchor": {"x": 0.5, "y": 0.5},
        "position": {"x": 16*0.8, "y": 9/2},
        "condition": (stage) => {
            return stage.flags["tutorial:hasAttackedAtRange"] == true
                && window.tutorial.hasDismissedCounterRange != true
                && stage.currentEncounterKey == 1
                && stage.turn.number >= 2
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">
                        The monster couldn't counterattack!<br/>
                        You're too far away to attack!
                    </div>
                    <div class="Link" onClick={() => window.tutorial.hasDismissedCounterRange = true}>
                        ✖ Dismiss
                    </div>
                </div>
            )
        }
    },
    {
        "anchor": {"x": 0.5, "y": 0.5},
        "position": {"x": 16*0.8, "y": 9/2},
        "condition": (stage) => {
            return stage.flags["tutorial:hasKilled"] == true
                && window.tutorial.hasDismissedCounterDeath  != true
                && stage.currentEncounterKey == 1
                && stage.turn.number >= 4
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">
                        The monster couldn't counterattack!<br/>
                        ...because they were dead. ☠️
                    </div>
                    <div class="Link" onClick={() => window.tutorial.hasDismissedCounterDeath = true}>
                        ✖ Dismiss
                    </div>
                </div>
            )
        }
    },
    {
        "anchor": {"x": 0, "y": 0},
        "position": {"x": 0.5, "y": 2.5},
        "condition": (stage) => {
            return stage.currentEncounterKey == 1
                && Object.values(stage.units).filter((unit) => {
                    return unit.affiliation == "bad"
                        && unit.isDead != true
                        && Zone.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
                }).length == 0
        },
        "content": (stage) => {
            return (
                <div class="TutorialBox">
                    <div class="Text">
                        👏 Well done!! End your turn, and<br/>
                        let's dive deeper into the dungeon~
                    </div>
                </div>
            )
        }
    },
]

function Element() {
    return (
        <span element={this.props.children}>
            {this.props.children}
        </span>
    )
}

function TutorialHud() {
    const style = {
        "top": (this.props.tutorial?.position?.y || 0) + "em",
        "left": (this.props.tutorial?.position?.x || 0) + "em",
        "margin-top": 4 * (this.props.tutorial?.anchor?.y || 0) * -1 + "em",
        "margin-left": 8 * (this.props.tutorial?.anchor?.x || 0) * -1 + "em",
        "align-items": this.props.tutorial?.anchor?.y == 0 && "flex-start",
        "justify-content": this.props.tutorial?.anchor?.x == 0 && "flex-start",
    }
    return (
        <div class="TutorialHud" isRendered={this.props.isRendered} style={style}>
            {this.props.tutorial?.content(this.props.stage)}
        </div>
    )
}

export default function TutorialHuds(stage) {
    let hasRendered = false
    return (
        <div class="TutorialHuds">
            {tutorials.map((tutorial) => {
                isRendered = (hasRendered == false) && (tutorial.condition instanceof Function ? tutorial.condition(stage) : (tutorial.condition ?? true))
                if(isRendered) hasRendered = true
                return (
                    <TutorialHud stage={stage} tutorial={tutorial} isRendered={isRendered}/>
                )
            })}
        </div>
    )
}
